import { render, staticRenderFns } from "./noChapter.vue?vue&type=template&id=6ea33fb5"
import script from "./noChapter.vue?vue&type=script&lang=ts"
export * from "./noChapter.vue?vue&type=script&lang=ts"
import style0 from "./noChapter.vue?vue&type=style&index=0&id=6ea33fb5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports